export default __webpack_public_path__ + "static/media/713.acffcac4.png";